import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M14.4624 17.539C12.7425 15.8192 12.3542 14.0993 12.2666 13.4102C12.2421 13.2197 12.3077 13.0286 12.444 12.8933L13.8358 11.5021C14.0405 11.2975 14.0768 10.9786 13.9234 10.7332L11.7074 7.29221C11.5376 7.02046 11.189 6.92238 10.9024 7.06574L7.34497 8.74118C7.11322 8.85529 6.97692 9.10151 7.00323 9.35848C7.18963 11.1293 7.96164 15.4824 12.2396 19.7606C16.5175 24.0388 20.87 24.8105 22.6417 24.997C22.8987 25.0233 23.1449 24.887 23.259 24.6552L24.9344 21.0977C25.0773 20.8118 24.9798 20.4641 24.7092 20.294L21.2682 18.0787C21.023 17.925 20.7041 17.9611 20.4993 18.1656L19.1081 19.5574C18.9728 19.6937 18.7817 19.7593 18.5912 19.7348C17.9021 19.6472 16.1823 19.2589 14.4624 17.539V17.539Z"
        fill="#2195F2"
      />
      <Circle cx="16" cy="16" r="16" fill="#2195F2" />
      <Path
        d="M14.697 17.1269C13.3381 15.768 13.0313 14.4091 12.962 13.8646C12.9427 13.7141 12.9945 13.5631 13.1022 13.4562L14.2019 12.357C14.3637 12.1953 14.3924 11.9434 14.2711 11.7495L12.5202 9.03069C12.3861 8.81597 12.1106 8.73847 11.8842 8.85174L9.07335 10.1755C8.89024 10.2657 8.78254 10.4602 8.80333 10.6633C8.95061 12.0624 9.5606 15.5019 12.9407 18.8822C16.3208 22.2625 19.7598 22.8722 21.1597 23.0195C21.3627 23.0403 21.5572 22.9326 21.6474 22.7495L22.9712 19.9386C23.0841 19.7127 23.0071 19.438 22.7932 19.3036L20.0744 17.5532C19.8806 17.4318 19.6287 17.4603 19.4669 17.622L18.3677 18.7216C18.2608 18.8293 18.1098 18.8811 17.9593 18.8618C17.4148 18.7926 16.0559 18.4857 14.697 17.1269V17.1269Z"
        fill="white"
      />
    </Svg>
  );
}

export default SvgComponent;
